<template>
	<div class="mini list-container">
		<div class="mini list-grid">
			<h6 class="list-title">{{ title }}</h6>
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default
{
	props:
	[
		'title',
		'readerName',
		'readerId',
		'readerProfileColour',
	]
}   
</script>